if (!customElements.get('main-blog')) {
  customElements.define(
    'main-blog',
    class MainBlog extends HTMLElement {
      constructor() {
        super();

        this.CLASSES = {
          loadingArticles: 'main-blog__article-list--is-loading',
        };

        this.content = this.querySelector('.main-blog__content');

        this.attachLinks();

        window.addEventListener('popstate', this.handlePopState.bind(this));
      }

      /**
       *
       * @param {HTMLAnchorElement} link
       * @param {Event} event
       */
      handleLinkClick(link, event) {
        event.preventDefault();

        this.setActiveLink(link.href);
      }

      handlePopState() {
        if (!this.activeUrlLink) return;

        this.setActiveLink(window.location.href, false);
      }

      /**
       *
       * @param {String} href
       */
      setActiveLink(href, pushUrl = true) {
        this.setUrl(href);
        pushUrl && this.pushUrl(href);
      }

      /**
       *
       * @param {String} href
       */
      setUrl(href) {
        const url = new URL(href);
        const params = new URLSearchParams(url.search);

        this.dataset.sectionId && params.append('section_id', this.dataset.sectionId);

        this.setLoading();

        fetch(url.pathname.toString() + `?${params.toString()}`)
          .then((res) => res.text())
          .then((html) => {
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            const content = parsedHTML.querySelector('.main-blog__content')?.innerHTML;

            if (this.content && content) {
              this.content.innerHTML = content;
            }

            this.attachLinks();
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.removeLoading();
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          });
      }

      /**
       *
       * @param {String} url
       */
      pushUrl(url) {
        window.history.pushState({}, '', url);
      }

      setLoading() {
        this.articleList?.classList.add(this.CLASSES.loadingArticles);
      }

      removeLoading() {
        this.articleList?.classList.remove(this.CLASSES.loadingArticles);
      }

      attachLinks() {
        if (!this.links) return;

        this.links.forEach((link) => {
          link.addEventListener('click', this.handleLinkClick.bind(this, link));
        });
      }

      /**
       * @type {NodeListOf<HTMLAnchorElement>}
       */
      get links() {
        return this.querySelectorAll('.main-blog__link');
      }

      get articleList() {
        return this.querySelector('.main-blog__article-list');
      }

      get activeUrlLink() {
        return window.location.href;
      }
    },
  );
}
